import { Loader2 } from "lucide-react";
import React from "react";

type SpinnerSize = "sm" | "md" | "lg" | "xl";
type SpinnerTone = "inherit" | "accent" | "muted";

const sizeClassName: Record<SpinnerSize, string> = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-8 w-8",
  xl: "h-10 w-10",
};

const toneClassName: Record<SpinnerTone, string> = {
  inherit: "text-current",
  accent: "text-[color:var(--ops-accent)]",
  muted: "text-slate-500",
};

interface InlineSpinnerProps {
  size?: SpinnerSize;
  tone?: SpinnerTone;
  className?: string;
  label?: string;
  decorative?: boolean;
}

const InlineSpinner: React.FC<InlineSpinnerProps> = ({
  size = "sm",
  tone = "inherit",
  className,
  label = "Loading",
  decorative = false,
}) => {
  if (decorative) {
    return (
      <Loader2
        className={`${sizeClassName[size]} ${toneClassName[tone]} animate-spin ${className ?? ""}`}
        aria-hidden="true"
      />
    );
  }

  return (
    <span role="status" aria-label={label} className="inline-flex items-center">
      <Loader2
        className={`${sizeClassName[size]} ${toneClassName[tone]} animate-spin ${className ?? ""}`}
        aria-hidden="true"
      />
      <span className="sr-only">{label}</span>
    </span>
  );
};

export default InlineSpinner;
